<template>
  <v-card>
    <v-data-table
        mobile-breakpoint="980"
        :headers="tableHeaders"
        :items="data"
        :page="options.page"
        :server-items-length="totalItems"
        :loading="loading"
        :footer-props="footerProps"
        :options.sync="options"
    >
      <template v-slot:top v-if="status === 'Active'">
        <v-toolbar flat>
          <v-spacer></v-spacer>
          <v-btn
              class="primary show-data-btn"
              :outlined="false"
              color="white"
              @click="createCompetitionDialogVisible = true"
          >{{ $t("create_competition") }}</v-btn
          >
        </v-toolbar>
      </template>
      <template v-slot:item.actions="{ item }">
        <div>
          <template v-if="status !== 'Deleted'">
            <v-icon  size="19" class="cursor-pointer mr-2" :title="$t('view')" @click="openCompetitionBoard(item.link)">
              mdi-eye
            </v-icon>
            <v-tooltip :open-on-hover="false"  :close-delay="100" top >
              <template v-slot:activator="{ on, attrs }">
                <v-icon class="mr-2 cursor-pointer" size="19" :title="$t('copy')" @click="copyLink(item.link)" v-bind="attrs"
                        v-on="on">
                  mdi-content-copy
                </v-icon>
              </template>
              <span>{{item.link}}</span>
            </v-tooltip>
          </template>
          <v-icon size="19" class="cursor-pointer mr-2" :title="$t('competition_information')" @click="viewCompetition(item)">
            mdi-cog-outline
          </v-icon>

          <v-menu left bottom :offset-y="true" v-if="status !== 'Deleted'">
            <template v-slot:activator="{ on, attrs }">
              <v-btn class="user-menu-button" icon v-bind="attrs" v-on="on">
                <v-icon>mdi-dots-horizontal</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item v-if="item.editable" @click="editCompetition(item)">
                <v-list-item-title>
                  <v-icon size="19" class="cursor-pointer" :title="$t('edit')">
                    mdi-pencil
                  </v-icon>
                  {{ $t('edit') }}
                </v-list-item-title>
              </v-list-item>
              <v-list-item @click="deleteCompetition(item)">
                <v-list-item-title>
                  <v-icon size="19" class="cursor-pointer" :title="$t('delete')">
                    mdi-delete
                  </v-icon>
                  {{ $t('delete') }}
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
      </template>
    </v-data-table>
    <create-competition
        @create-competition="createCompetition"
        @update-competition="updateCompetition"
        :competition="editableCompetition"
        :badges="badges"
        :companies="companies"
        v-if="createCompetitionDialogVisible"
        :is-visible="createCompetitionDialogVisible"
        @close="closeCompetitionForm"
    />
    <informationdialog
        :large="true"
        :title="$t('competition_information')"
        :button-text="$t('ok')"
        :visible="informationdialogVisible"
        @informationdialog:buttonClick="informationdialogVisible = !informationdialogVisible"
    >
      <template #body>
        <competition-info class="px-4" :enddate="competitionInfo.enddate" :startdate="competitionInfo.startdate" :competition-title="competitionInfo.title" :badges="competitionInfo.badges" :companies="competitionInfo.companies" />
      </template>
    </informationdialog>
    <Confirmationdialog
        :visible="dialogDelete"
        @confirmationdialog:cancelClick="closeDelete"
        @confirmationdialog:confirmClick="deleteItemConfirm"
    >
      <template v-slot:cardText>{{ $t('are_you_sure_delete') }}</template>
    </Confirmationdialog>

  </v-card>
</template>
<script>
import Informationdialog from "@/components/InformationDialog.vue";
import CompetitionInfo from "@/components/CompetitionInfo.vue";
import CreateCompetition from "@/components/CreateCompetition.vue";
import {mapActions, mapGetters} from "vuex";
import {apiCall} from "@/utils/api";
import Confirmationdialog from "@/components/ConfirmationDialog.vue";

export default {
  name: 'CompetitionTable',
  components: {Confirmationdialog, CompetitionInfo, Informationdialog, CreateCompetition },
  props: {
      status: {
        required: true,
        default: "Active"
      }
  },
  data: (context) => ({
    dialogDelete: false,

    footerProps: {
      "items-per-page-options": [20, 30, 50],
    },
    options: {
      sortBy: ["createddate"],
      sortDesc: [true],
      page: 1,
    },
    totalItems: 0,
    data: [],
    companies: [],
    badges: [],
    loading: false,
    tableHeaders: [
      {
        text: context.$t("id"),
        value: "id",
        align: "center",
        sortable: false
      },
      {
        text: context.$t("title"),
        value: "title",
        align: "center",
      },
      {
        text: context.$t("start_date"),
        value: "startdate",
        align: "center",
        sortable: true,
      },
      {
        text: context.$t("end_date"),
        value: "enddate",
        align: "center",
        sortable: true,
      },
      {
        text: context.$t("created_date"),
        value: "createddate",
        align: "center",
        sortable: true,
      },
      {
        text: context.$t("actions"),
        value: "actions",
        align: "center",
        sortable: false,
      },
    ],
    createCompetitionDialogVisible: false,
    editableCompetition: null,
    informationdialogVisible: false,
    competitionInfo: {
      startdate: null,
      enddate: null,
      title: null,
      badges: [],
      companies: []
    },
    itemForDelete: {
      competitionId: null,
      currentStatus: null
    }
  }),
  async created() {
    await this.getCompanies();
    await this.getBadges();
  },
  watch: {
    dialogDelete(val) {
      val || this.closeDelete();
    },
    options: {
      handler() {
        this.getDataFromApi();
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters("auth", ["getProfile"]),
  },
  methods: {
    ...mapActions("service", ["setSnackbar"]),
    deleteItemConfirm() {
      // api remove
      this.confirmDeleteCompetition();
      this.closeDelete();
    },
    closeDelete() {
      this.dialogDelete = false;
    },
    viewCompetition(competition) {
      console.log(competition.badges)
      this.competitionInfo.title = competition.title;
      this.competitionInfo.startdate = competition.startdate;
      this.competitionInfo.enddate = competition.enddate;
      this.competitionInfo.badges = competition.badges.map(e => {return {id: e.id, limit: e.limit, points: e.points, smallimage: e.badge.smallimage, value: e.badge.name}});
      this.competitionInfo.companies = this.companies.filter(e => competition.companies.includes(e.id));
      this.informationdialogVisible = true;
    },
    closeCompetitionForm() {
      this.editableCompetition = null;
      this.createCompetitionDialogVisible = false
    },
    async copyLink(link) {
      const type = "text/plain";
      const clipboardItemData = {
        [type]: link,
      };
      // eslint-disable-next-line no-undef
      const clipboardItem = new ClipboardItem(clipboardItemData);
      await navigator.clipboard.write([clipboardItem]);
    },
    getDataFromApi() {
      this.loading = true;
      const params = {
        page: this.options.page - 1,
        sortDirection: this.options.sortDesc[0] == false ? "asc" : "desc",
        sortField: this.options.sortBy[0] || "createddate",
        perpage: this.options.itemsPerPage,
        status: this.status
      };

      apiCall(
          "get",
          "competitions",
          {
            params: params,
          },
          true
      )
          .then((response) => {
            if (response.data.status == true) {
              const DASHBOARD_LINK = process.env.VUE_APP_DASHBOARD_URL;
              this.data = response.data.result.content.map((e) => ({...e, link: DASHBOARD_LINK.concat('/', e.id)}));
              this.totalItems = response.data.result.totalElements;
            } else {
              this.setSnackbar({
                color: "error",
                text: this.$t("unknown_error"),
                toggle: true,
              });
            }
          })
          .catch(() => {
            this.setSnackbar({
              color: "error",
              text: this.$t("unknown_error"),
              toggle: true,
            });
          })
          .finally(() => (this.loading = false));
    },
    async getCompanies() {
      await apiCall("get", "companies/getlist", true).then((response) => {
        this.companies = response.data;
      });
    },
    async getBadges() {
      await apiCall("get", "defaultbadges/getlist", true).then((response) => {
        this.badges = response.data.map((e) => ({...e, points: 1, limit: ""}));
      });
    },
    async createCompetition(competition) {
      this.loading = true;
      await apiCall("post", "competitions/create", {data: competition}, true)
          .then((response) => {
            if (response.data.status == true) {
              const DASHBOARD_LINK = process.env.VUE_APP_DASHBOARD_URL;
              this.data = response.data.result.result.content.map((e) => ({
                ...e,
                link: DASHBOARD_LINK.concat('/', e.id)
              }));
              this.totalItems = response.data.result.result.totalElements;
              const hasMessage = response.data.result.addedNewDefaultBadges;

              this.setSnackbar({
                color: "success",
                text: `${this.$t("competition_created")}${hasMessage ? ". " + this.$t("added_default_badges") : ''}`,
                toggle: true,
              });

            } else {
              this.setSnackbar({
                color: "error",
                text: this.$t("unknown_error"),
                toggle: true,
              });
            }
          })
          .catch(() => {
            this.setSnackbar({
              color: "error",
              text: this.$t("unknown_error"),
              toggle: true,
            });
          })
          .finally(() => {
            this.loading = false
          });
    },
    editCompetition(competition) {
      this.editableCompetition = competition;
      this.createCompetitionDialogVisible = true;
    },
    async updateCompetition(competition) {
      this.loading = true;
      await apiCall("post", "competitions/update", {data: competition}, true)
          .then((response) => {

            if (response.data.status == true) {
              this.getDataFromApi();
              const hasMessage = response.data.result.addedNewDefaultBadges;

              this.setSnackbar({
                color: "success",
                text: `${this.$t("competition_updated")}${hasMessage ? ". " + this.$t("added_default_badges") : ''}`,
                toggle: true,
              });

            } else {
              this.setSnackbar({
                color: "error",
                text: this.$t("unknown_error"),
                toggle: true,
              });
            }
          })
          .catch(() => {
            this.setSnackbar({
              color: "error",
              text: this.$t("unknown_error"),
              toggle: true,
            });
          })
          .finally(() => (this.loading = false));
    },
    openCompetitionBoard(link) {
      window.open(link, "_blank");
    },
    deleteCompetition(item) {
      this.itemForDelete.competitionId = item.id;
      this.itemForDelete.currentStatus = this.status;

      this.dialogDelete = true;
    },
    confirmDeleteCompetition() {
      const params = {
        competitionId: this.itemForDelete.competitionId,
        currentStatus: this.itemForDelete.currentStatus
      }

      this.loading = true;

      apiCall(
          "post",
          "competitions/delete",
          {
            data: params,
          },
          true
      ).then((response) => {
        if (response.data) {
          this.setSnackbar({
            color: response.data.status ? "success" : "error",
            text: response.data.status ? this.$t('competition_successfully_deleted') : response.data.result,
            toggle: true,
          });
          this.getDataFromApi();
        } else {
          this.setSnackbar({
            color: "error",
            text: "Unknown error",
            toggle: true,
          });
        }

      });
    }
  }
}
</script>
<style scoped>
.leaderboard-calendar-btn--wrapper {
  padding: 0;
  display: flex;
  justify-content: space-between;
}
@media (max-width: 480px) {
  .leaderboard-calendar-btn--wrapper {
    display: flex;
    flex-wrap: wrap;
    row-gap: 1rem;
    justify-content: space-between;
  }
  .leaderboard-btn--wrapper {
    flex-direction: column;
  }
  .show-data-btn,
  .export-data-btn {
    margin-left: 0 !important;
    margin-right: 0 !important;
    width: 100%;
    margin-top: 4px;
    margin-bottom: 4px;
  }
}
.v-expansion-panel-header {
  padding: 0;
}
@media only screen and (max-width: 959px) {
  .badge-list-items-card {
    padding: 0;
  }
  .badge-list-items {
    padding: 0;
  }
  .badge-list-items .name--wrapper,
  .badge-list-items .name--content,
  .badge-list-items .earnedbadge--wrapper,
  .badge-list-items .earnedbadge--content {
    transform: none;
    border: none;
  }
}
.heading--item {
  padding-left: 0;
}
.position {
  font-size: 24px;
  font-weight: 500;
  min-width: 50px;
  width: auto;
  padding: 0;
  text-align: center;
}
.v-list-item__avatar {
  z-index: 2;
}
.name--wrapper {
  background: white;
  border: 1px solid gray;
  transform: skew(-30deg);
  padding-left: 30px;
  margin-left: -20px !important;
  z-index: 1;
}
.name--content {
  transform: skew(30deg);
}
.earnedbadge--wrapper {
  background-color: #a0ce5f;
  transform: skew(-30deg);
  display: flex;
  /* padding: 0; */
  justify-content: center;
  /* height: 48px; */
}
.earnedbadge--content {
  text-align: center;
  /* font-size: 24px; */
  transform: skew(30deg);
}
.currentscore--wrapper {
  display: flex;
  /* padding: 0; */
  justify-content: center;
  transform: skew(-30deg);
  /* height: 48px; */
}
.currentscore--content {
  color: white;
  text-align: center;
  transform: skew(30deg);
}
.leaderboard /deep/ .v-virtual-scroll__item:hover {
  background: #ff1493;
  cursor: pointer;
}
.leaderboard /deep/ .v-virtual-scroll__item.item--active {
  background: #ff1493;
}
.v-list-item.item--active .name--wrapper,
.v-list-item.item--active .earnedbadge--wrapper,
.v-list-item.item--active .currentscore--wrapper {
  border-top: 2px solid #ff1493 !important;
  border-bottom: 2px solid #ff1493 !important;
}
.cursor-pointer{
  cursor: pointer;
}
</style>